/* eslint-disable camelcase */
import {  useState } from "react";
import { Nav, NavDropdown } from "react-bootstrap";
import { useNavigate,useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearModalContent } from "src/redux/modules/modalEvent";
import Avatar from "src/components/base/Avatar/Avatar";
import { Weight } from "src/latest/src/types";
import { Typography } from "src/latest/src/components";
import { booleanFlagValue, ExternalLinks, UserRoles } from "../../constants";


type Props = {
    onLogout: (reason: string) => void;
    textWeight?: Weight;
    isDirectoryPlatform: boolean;
};

export const ProfileAvatarDropdown = ({ textWeight, onLogout, isDirectoryPlatform }: Props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const { loggedInUser } = useSelector(
        ({ authentication }: any) => authentication
    );
    const configuration = useSelector((state: any) => state.configuration);

    const { userRole, full_name, id, user_type } = loggedInUser;
    const [dropdownToggle, setDropdownToggle] = useState(false);

    // TODO: Remove this unused code after testing
    // const [avatarTimestamp, setAvatarTimestamp] = useState<any>(Date.now());

    const isCalendarEnable = useSelector(
        (state: any) => state?.configuration?.isCalendarEnable
    );

    // TODO: Remove this unused code after testing
    // useEffect(() => {
    //     setAvatarTimestamp(Date.now());
    // }, [profilePic]);

    const handleNav = (route: string, options?: any) => {
        dispatch(clearModalContent());

        if (route === "/logout") {
            onLogout("MANUAL");

            return;
        }

        navigate(route, options);
    };

    const handleNavNewTab = (url: string) => {
        dispatch(clearModalContent());

        if (url) {
            window.open(url, "_blank");
        }
    };

    const handleProfileRedirect = (hash: string) => {
        handleNav(`/profile/${loggedInUser.id}/#${hash}`);
    };

    return (
        !location.pathname.includes('/meeting-info') ? (  <Nav.Item className="header__container">
            <NavDropdown
                id="collasible-nav-dropdown"
                className="user-menu"
                show={dropdownToggle}
                onToggle={() => {
                    setDropdownToggle(!dropdownToggle);
                }}
                title={
                    <div className="header__avatar">
                        <Avatar
                            self={true}
                            userId={id}
                            fullName={full_name}
                            photoUrl={loggedInUser?.profile_pic}
                            hideImage={true}
                        />
                    </div>
                }
            >
                {/* {!user_type?.includes("CLIENT") && ( */}
                    <NavDropdown.Item
                        onClick={() =>
                            handleProfileRedirect('profile')
                        }
                    >
                        <Typography
                            color="color-30"
                            weight={textWeight || "semi-bold"}
                            variant="size-16"
                        >
                            My Profile
                        </Typography>
                    </NavDropdown.Item>
                {/* )} */}

                {(user_type?.includes(UserRoles?.CLIENT) ||
                    user_type?.includes(UserRoles?.THERAPIST)) && (
                    <NavDropdown.Item
                        onClick={() =>
                            handleProfileRedirect('appointments')
                        }
                    >
                        <Typography
                            color="color-30"
                            weight={textWeight || "semi-bold"}
                            variant="size-16"
                        >
                            Appointments
                        </Typography>
                    </NavDropdown.Item>
                )}

                {(user_type?.includes(UserRoles?.SCHEDULER) ||
                    user_type?.includes(UserRoles?.PRACTICE_ADMIN)) && (
                    <NavDropdown.Item
                        onClick={() =>
                            handleNav("/therapy/clinician-availability")
                        }
                    >
                        <Typography
                            color="color-30"
                            weight={textWeight || "semi-bold"}
                            variant="size-16"
                        >
                            Availability
                        </Typography>
                    </NavDropdown.Item>
                )}

                {userRole?.toLowerCase() !== UserRoles?.CLIENT?.toLowerCase() && isCalendarEnable === "true" && (
                    <NavDropdown.Item
                        onClick={() => handleNav("/therapy/calendar")}
                    >
                        <Typography
                            color="color-30"
                            weight={textWeight || "semi-bold"}
                            variant="size-16"
                        >
                            Calendar
                        </Typography>
                    </NavDropdown.Item>
                )}
                {isDirectoryPlatform && user_type?.includes(UserRoles?.THERAPIST) && (
                    <NavDropdown.Item
                        onClick={() => handleNav("/therapy/account")}
                    >
                        <Typography
                            color="color-30"
                            weight={textWeight || "semi-bold"}
                            variant="size-16"
                        >
                            Account
                        </Typography>
                    </NavDropdown.Item>
                )}

                {
                    !isDirectoryPlatform && user_type?.includes(UserRoles?.CLIENT) && configuration?.billingDashboardEnabled === booleanFlagValue?.TRUE && (
                        <NavDropdown.Item
                            onClick={() => handleNav("/payment/client")}
                        >
                            <Typography
                                color="color-30"
                                weight={textWeight || "semi-bold"}
                                variant="size-16"
                            >
                                Payment
                            </Typography>
                        </NavDropdown.Item>
                    )
                }

                <NavDropdown.Item
                    onClick={() =>
                        handleNav(
                            `${
                                userRole.toLowerCase() !== UserRoles?.CLIENT?.toLowerCase()
                                    ? "/therapy"
                                    : ""
                            }/settings${
                                userRole.toLowerCase() === UserRoles?.CLIENT?.toLowerCase()
                                    ? "/user"
                                    : ""
                            }`
                        )
                    }
                >
                    <Typography
                        color="color-30"
                        weight={textWeight || "semi-bold"}
                        variant="size-16"
                    >
                        Settings
                    </Typography>
                </NavDropdown.Item>
                
                {/* commented this for now but we can use this in future for stripe connect onboarding. */}
                {/* {loggedInUser?.metadata?.ALLOWED_STRIPE_ONBOARDING === true && (
                    <NavDropdown.Item onClick={() => handleNav('/payments/onboarding')}>
                        <Typography
                            color="color-30"
                            weight={textWeight || "semi-bold"}
                            variant="size-16"
                        >
                            Payments
                        </Typography>
                    </NavDropdown.Item>
                )} */}

                <NavDropdown.Item
                    onClick={() => handleNav("/resources/support-options")}
                >
                    <Typography
                        color="color-30"
                        weight={textWeight || "semi-bold"}
                        variant="size-16"
                    >
                        Support
                    </Typography>
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => handleNav("/logout")}>
                    <Typography
                        color="color-30"
                        weight={textWeight || "semi-bold"}
                        variant="size-16"
                    >
                        Log Out
                    </Typography>
                </NavDropdown.Item>
                <NavDropdown.Item>
                    <hr className="header-separator" />
                </NavDropdown.Item>
                <NavDropdown.Item
                    onClick={() => handleNavNewTab(ExternalLinks.termsofservice)}
                >
                    <Typography
                        color="color-28"
                        weight={textWeight || "semi-bold"}
                        variant="size-12"
                    >
                        Terms of Service
                    </Typography>
                </NavDropdown.Item>
                <NavDropdown.Item
                    onClick={() => handleNavNewTab(ExternalLinks.privacyPolicy)}
                >
                    <Typography
                        color="color-28"
                        weight={textWeight || "semi-bold"}
                        variant="size-12"
                    >
                        Privacy Policy
                    </Typography>
                </NavDropdown.Item>
            </NavDropdown>
        </Nav.Item>) : null
    );
};
